import React from "react";
import { notification, Button } from "antd";

const HNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  HNotification.notify = ({
    type,
    message,
    description,
    placement = "topRight",
    icon = false,
    iconClass = "",
    button = false,
    buttonText = "",
    duration = 5,
    btnClick = () => {},
    buttonLink = "",
  }) => {
    api[type]({
      message,
      description: <div style={{ minHeight: 20 }}>{description}</div>,
      props: { "data-cy": `${type}-notification` },
      placement,
      icon: icon ? <div className={iconClass} /> : null,
      btn: button ? (
        <div style={{ display: "inline-block", height: "28px" }}>
          <Button
            size="small"
            onClick={btnClick}
            href={buttonLink}
            className="hs-button-primary hs-text-primary hs-fw-600 hs-fs-14"
          >
            {buttonText}
          </Button>
        </div>
      ) : null,
      duration,
    });
  };

  return <>{contextHolder}</>;
};

export default HNotification;
